export const read_message = `mutation read_message($input: Int!){
    read_message(input: $input)
}`;
